import * as React from 'react';
import moment from 'moment';
import { Link as RouterLink } from 'react-router-dom';
import { Translate } from '../../shared/LanguageService';
import IUpcomingDroneBooking from './IUpcomingDroneBooking';

const DEFAULT_TEXT_KEY = 'photographers/drone/upcoming-bookings/confirmation/text';

type DroneBookingsWarningContentProps = {
    bookings: IUpcomingDroneBooking[];
    textKey?: string;
    linkToOrders?: boolean;
};

const DroneBookingsWarningContent = ({
    bookings,
    textKey,
    linkToOrders
}: DroneBookingsWarningContentProps) => (
    <div>
        <p>{Translate(textKey ? textKey : DEFAULT_TEXT_KEY)}</p>
        <ul>
            {bookings.map((booking: IUpcomingDroneBooking) => (
                <li key={booking.calendarItemId}>
                    {moment(booking.dateStart).format('YYYY-MM-DD HH:mm')}
                    {' — '}
                    {linkToOrders ? (
                        <RouterLink
                            to={`/orders/${booking.orderId}/basic`}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {booking.orderNumber}
                        </RouterLink>
                    ) : (
                        booking.orderNumber
                    )}
                </li>
            ))}
        </ul>
    </div>
);

export default DroneBookingsWarningContent;
